module.exports = __webpack_public_path__ + "img/445.3bc73bb3.jpg";